import { serialize } from "@jscad/stl-serializer";
import type { StorageDesign } from "../domain/design";
import { createTrayGeometry } from "./trayGeometry";

export function createStl(design: StorageDesign): string {
  const geometry = createTrayGeometry(design);
  const serialized = serialize({ binary: false }, geometry) as string | string[];

  return Array.isArray(serialized) ? serialized.join("") : serialized;
}
